import { getParams, isKozojiCode } from '../utils/params';
import Kozoji from './Kozoji';
import Main from './Main';
import { sendLogs } from '../utils/sendLogs';
import React from 'react';

/** /（ルート）パスにひも付くコンポーネント。  */
const Root = () => {
  /** URLパラメーター。 */
  const params = new URLSearchParams(location.search);
  /** バス停コード。 */
  const busStopCode = getParams(params, 'busStopCode');

  React.useEffect(() => {
    // ログを送る
    (async () => {
      await sendLogs(location.search, location.pathname);
    })();
  }, []);
  // 高蔵寺案件用のパラメーターが指定されている場合は、高蔵寺用のコンポーネントを表示する。
  if (isKozojiCode(busStopCode)) {
    return <Kozoji />;
  } else {
    // それ以外（未設定も含む）の場合は、広小路本町・納屋橋用のコンポーネントを表示する。
    // （現状は以下のコンポーネント内でパラメーターチェックが実行されるため、
    //   この階層でパラメーターチェックはしていない。今後この階層でチェックをやっても良いかもしれない？）
    return <Main />;
  }
};

export default Root;
